import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import Pusher from 'pusher-js';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  private pusher: Pusher;
  private channels: Map<string, any> = new Map();
  private posPaymentSubject = new Subject<any>();
  posPaymentEvent$ = this.posPaymentSubject.asObservable();
  private partialPaymentSubject = new Subject<string>();
  partialPayment$ = this.partialPaymentSubject.asObservable();

  constructor(private http: HttpClient) {
    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster,
      wsHost: environment.pusher.host,
      wsPort: environment.pusher.port,
      // encrypted: true,
    });
  }

  subscribeToChannel(channelName: string) {
    if (!this.channels.has(channelName)) {
      const channel = this.pusher.subscribe(channelName);
      console.log(channel);
      this.channels.set(channelName, channel);
    }
    return this.channels.get(channelName);
  }

  unsubscribeFromChannel(channelName: string) {
    if (this.channels.has(channelName)) {
      this.pusher.unsubscribe(channelName);
      this.channels.delete(channelName);
    }
  }

  getChannel(channelName: string) {
    return this.channels.get(channelName);
  }

  // Optional: Method to unsubscribe from all channels
  unsubscribeAll() {
    this.channels.forEach((_, channelName) => {
      this.pusher.unsubscribe(channelName);
    });
    this.channels.clear();
  }

  emitPosPaymentEvent(data: any) {
    this.posPaymentSubject.next(data);
  }

  emitPartialPaymentEvent(uid: string) {
    this.partialPaymentSubject.next(uid);
  }
}
